import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {CustomDomainIndexComponent} from '@common/custom-domain/custom-domain-index/custom-domain-index.component';
import {DatatableService} from '@common/datatable/datatable.service';
import {CustomDomain} from '@common/custom-domain/custom-domain';
import {CurrentUser} from '@common/auth/current-user';
import {CustomDomainService} from '@common/custom-domain/custom-domain.service';
import {Toast} from '@common/core/ui/toast.service';
import {ActivatedRoute, Router} from '@angular/router';
import {WorkspacesService} from '@common/workspaces/workspaces.service';
import {ActiveAppSectionService} from '../active-app-section.service';
import {Subscription} from 'rxjs';
import {CUSTOM_DOMAIN_FILTERS} from '@common/custom-domain/custom-domain-index/custom-domain-filters';

@Component({
    selector: 'link-domain',
    templateUrl: './link-domain.component.html',
    styleUrls: ['./link-domain.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatatableService],
})
export class LinkDomainComponent
    extends CustomDomainIndexComponent
    implements OnInit, OnDestroy
{
    private workspaceSub: Subscription;

    constructor(
        public datatable: DatatableService<CustomDomain>,
        public currentUser: CurrentUser,
        protected customDomains: CustomDomainService,
        protected toast: Toast,
        protected router: Router,
        protected route: ActivatedRoute,
        private workspaces: WorkspacesService,
        private activeSection: ActiveAppSectionService
    ) {
        super(datatable, currentUser, customDomains, toast, router);
    }

    ngOnInit() {
        this.workspaceSub = this.workspaces.activeId$.subscribe(() => {
            this.setFilters();
        });
        this.datatable.init({
            uri: CustomDomainService.BASE_URI,
            staticParams: {
                userId: !this.showUserColumn()
                    ? this.currentUser.get('id')
                    : null,
            },
        });
    }

    ngOnDestroy() {
        this.workspaceSub.unsubscribe();
    }

    showUserColumn(): boolean {
        // show in admin and if active workspace is not personal
        return this.activeSection.admin || !!this.workspaces.activeId$.value;
    }

    private setFilters() {
        this.filters = CUSTOM_DOMAIN_FILTERS.filter(
            f =>
                (f.key !== 'user_id' || this.showUserColumn()) &&
                f.key !== 'global'
        );
    }
}

